
import { defineComponent, onMounted, PropType, ref } from 'vue'
import { topicDetail } from '@/api/assist'
import { getLang } from '@/hooks/lang'

export default defineComponent({
  props: {
    topicDetail: {
      type: Object as PropType<topicDetail>,
      required: false,
      default: () => ({}),
    },
  },
  setup(props) {
    const abbrev = ref([] as string[])
    const lang = getLang()
    const topicSentence = ref<string>('')
    const anaphorConList = ref<string[]>([])

    const anaphorHandle = () => {
      const anaphorIndexList = props.topicDetail.anaphorList
      if (anaphorIndexList.length > 0) {
        for (let i = 0; i <= anaphorIndexList.length - 1; i++) {
          let lastIndex = 0
          const posIndex = `<span class='anaphora'>${i + 1}</span>`
          const anaphor = `<span style='color:#444444'>${anaphorIndexList[i].anaphor}</span>`
          const antecedent = anaphorIndexList[i].antecedent
          const conLabel = `${anaphor}${posIndex} = ${antecedent}`
          anaphorConList.value.push(conLabel)

          if (i === 0) {
            lastIndex = anaphorIndexList[i].anaphorSpan[1]
            topicSentence.value =
              props.topicDetail.topicSentence.slice(0, lastIndex) +
              posIndex +
              props.topicDetail.topicSentence.slice(lastIndex)
          } else {
            lastIndex = anaphorIndexList[i].anaphorSpan[1] + 31 * i
            topicSentence.value =
              topicSentence.value.slice(0, lastIndex) +
              posIndex +
              topicSentence.value.slice(lastIndex)
          }
        }
      } else {
        topicSentence.value = props.topicDetail.topicSentence
      }
    }

    const abbrevHandle = () => {
      const abbrevMap = props.topicDetail.abbreviations
      for (const key in abbrevMap) {
        abbrev.value.push(abbrevMap[`${key}`].concat(` ( ${key} )`))
      }
    }

    onMounted(() => {
      anaphorHandle()
      abbrevHandle()
    })
    return {
      abbrev,
      lang,
      topicSentence,
      anaphorConList,
    }
  },
})
